import {Injectable} from '@angular/core';

import {ApiAlgoResultResponse} from './api-algo-result-response';
import {InfusionResultsV1} from './infusion-results-v1';
import {ConfigService} from '../config/config.service';
import {Utils} from '@astek/utils';

@Injectable()
export class ResultsParserService {

  constructor(
    private readonly _configService: ConfigService,
  ) {
  }

  public parseInfusionResultsV1(results: ApiAlgoResultResponse | null): InfusionResultsV1 | null {
    if (Utils.isNull(results) || !this.isResultsV1(results)) {
      return null;
    }
    return results.infusionResults as InfusionResultsV1;
  }

  public isResultsV1(results: ApiAlgoResultResponse | null): boolean {
    return Utils.isNotNull(results) && this.isVersionPriorOrEqualTo(
      results.version,
      this._configService.config.resultsVersions.maxV1,
    );
  }

  private isVersionPriorOrEqualTo(version: string, referenceVersion: string): boolean {
    return version.localeCompare(
      referenceVersion,
      undefined,
      {
        numeric: true,
        sensitivity: 'base',
      },
    ) <= 0;
  }

}
